import { __assign } from "tslib";
import React from 'react';
import { omit } from '../../utils';
import { Spinner } from '../spinner/Spinner';
import { BootstrapButton } from '../bootstrap-button/BootstrapButton';
;
var omitKeys = ['loadingContent', 'defaultContent', 'isLoading'];
var darkButtons = ['danger', 'info', 'success'];
/**
 * The `IndeterminateButton` works similar to reactstrap's Button component. Use it to inform users about the status of ongoing processes, such submitting a form, or saving updates.
 *
 * Pass the `isLoading` prop to disable the button (to prevent additional clicks) and render a `Spinner` inside the button.
 */
export var IndeterminateButton = function (props) {
    var isLoading = props.isLoading, color = props.color, children = props.children;
    var iconColor = darkButtons.indexOf(color) > -1 ? 'white' : '#898989';
    var buttonIcon = isLoading
        ? React.createElement(Spinner, { size: "xs", color: iconColor, className: "mr-2" })
        : undefined;
    return (React.createElement(BootstrapButton, __assign({ disabled: isLoading }, omit(props, omitKeys)),
        buttonIcon,
        React.createElement("span", { className: "mx-auto" }, children)));
};
IndeterminateButton.defaultProps = {
    color: 'primary',
    size: '',
    block: false,
    isLoading: false,
};
export default IndeterminateButton;
//# sourceMappingURL=IndeterminateButton.js.map